import { DocumentViewerV2 } from '@dealstack/frontend/shared/components/DocumentViewerV2/DocumentViewerV2';
import { Modal } from '@mantine/core';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { DocumentViewerV2Props } from './DocumentViewerV2.types';

interface Props extends DocumentViewerV2Props {
	opened: boolean;
	onClose: () => void;
	className?: string;
}

const DocumentViewerModalV2 = forwardRef<HTMLDivElement, Props>(
	({ className, opened, onClose, ...props }, ref) => {
		return (
			<Modal
				className={className}
				opened={opened}
				onClose={onClose}
				size="80vw"
				centered
				trapFocus={false}
				withCloseButton={false}
			>
				<DocumentViewerV2
					{...props}
					onCancelPassword={onClose}
					onBackArrowClick={onClose}
					ref={ref}
				/>
			</Modal>
		);
	}
);

const Styled = styled(DocumentViewerModalV2)`
	.mantine-Modal-body {
		min-height: 90vh;
		max-height: 90vh;
		display: flex;
		flex-direction: column;
		gap: 1rem;
		overflow: hidden;
	}
`;

export { Styled as DocumentViewerModalV2 };
